var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4963 14.0029C14.2211 14.0029 13.9961 14.228 13.9991 14.5031C13.9991 14.7783 14.2241 15.0033 14.4993 15.0033C14.7744 15.0033 14.9995 14.7783 14.9995 14.5031C14.9995 14.228 14.7744 14.0029 14.4963 14.0029",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4963 9.00293C14.2211 9.00293 13.9961 9.22802 13.9991 9.50314C13.9991 9.77825 14.2241 10.0033 14.4993 10.0033C14.7744 10.0033 14.9995 9.77825 14.9995 9.50314C14.9995 9.22802 14.7744 9.00293 14.4963 9.00293",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4963 19.0029C14.2211 19.0029 13.9961 19.228 13.9991 19.5031C13.9991 19.7783 14.2241 20.0033 14.4993 20.0033C14.7744 20.0033 14.9995 19.7783 14.9995 19.5031C14.9995 19.228 14.7744 19.0029 14.4963 19.0029",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4963 3.99902C14.2211 3.99902 13.9961 4.22412 13.9991 4.49923C13.9991 4.77435 14.2241 4.99944 14.4993 4.99944C14.7744 4.99944 14.9995 4.77435 14.9995 4.49923C14.9995 4.22412 14.7744 3.99902 14.4963 3.99902",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49626 14.0029C9.22115 14.0029 8.99605 14.228 8.99905 14.5031C8.99905 14.7783 9.22415 15.0033 9.49926 15.0033C9.77438 15.0033 9.99947 14.7783 9.99947 14.5031C9.99947 14.228 9.77438 14.0029 9.49626 14.0029",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49626 9.00293C9.22115 9.00293 8.99605 9.22802 8.99905 9.50314C8.99905 9.77825 9.22415 10.0033 9.49926 10.0033C9.77438 10.0033 9.99947 9.77825 9.99947 9.50314C9.99947 9.22802 9.77438 9.00293 9.49626 9.00293",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49626 19.0029C9.22115 19.0029 8.99605 19.228 8.99905 19.5031C8.99905 19.7783 9.22415 20.0033 9.49926 20.0033C9.77438 20.0033 9.99947 19.7783 9.99947 19.5031C9.99947 19.228 9.77438 19.0029 9.49626 19.0029",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49626 3.99902C9.22115 3.99902 8.99605 4.22412 8.99905 4.49923C8.99905 4.77435 9.22415 4.99944 9.49926 4.99944C9.77438 4.99944 9.99947 4.77435 9.99947 4.49923C9.99947 4.22412 9.77438 3.99902 9.49626 3.99902",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.f8a88b5dc5cc9b3283ff183212a7f577.svg";
export { ForwardRef as ReactComponent };